import { AsEntityTypes } from '@frontend-site/shared/data';
import { EntityDetailsViewContext } from './seemore-ui-view-context.model';

/**
 * Builds the `entity_details` wire object for the single entity currently open.
 * `entity_type` is the AsEntityTypes enum KEY (e.g. 'TM_DEFECT', 'TASK' for a correction),
 * matching the token vocabulary seemore's read tools expect. `entityId` must be the entity's
 * user-facing id (appId for all types except TM_TEST, whose user-facing id is the `testId` field);
 * seemore maps it to any internal id server-side. `internalId`, when supplied, is the entity's
 * internal PK `id` — emitted as the redacted, server-side-only `entity_internal_id` (Task 3c);
 * the caller (each detail component) passes both. See design section 2.2.
 */
export function buildEntityDetailsViewContext(
    entityType: AsEntityTypes,
    entityId: number,
    internalId?: number | null
): EntityDetailsViewContext {
    return {
        type: 'entity_details',
        entity_type: AsEntityTypes[entityType],
        entity_user_facing_id: entityId,
        ...(internalId != null ? { entity_internal_id: internalId } : {})
    };
}
